export const deplomes = [
  {
    id: 0,
    title: "LICENCE EN FINANCE",
    description:
      "La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise.",
    link: "BUSINESS",
    long_desc: `La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise. Les étudiants développeront également des compétences en leadership, en gestion de projet et en résolution de problèmes. Ce programme vise avant tout à former des leaders atypiques et créatives à l'impact positif sur le monde des entreprises et de la société.`,
    duration: " 3 ans",
    duration_type: "Temps Plein",
    cond_adm: " Baccalauréat ou équivalent ",
    langue: "Français - English ",
    type: "lisence",
    objectifs: `<div>
    <h2><strong>OBJECTIFS DU DIPLOME NATIONAL D'ARCHITECTE :</strong></h2>
    <p>1 - Fournir une éducation architecturale complète en développant la créativité, les compétences techniques et la sensibilité artistique des étudiants.</p>
    <p>2 - Former les étudiants à résoudre des problèmes architecturaux complexes en tenant compte des besoins fonctionnels, esthétiques, environnementaux et sociaux.</p>
    <p>3 - Offrir une expérience pratique grâce à une année de stage professionnalisant, permettant aux étudiants d'appliquer les connaissances théoriques dans un contexte professionnel.</p>
    <p>4 - Cultiver des compétences en communication, en collaboration et en gestion de projet, essentielles pour le succès dans la pratique architecturale.</p>
    <p>5 - Encourager une réflexion critique grâce au mémoire de stage, favorisant une analyse approfondie des expériences professionnelles.</p>
    <p>6 - Élargir les horizons des étudiants par le biais de voyages d'études internationaux, enrichissant leur compréhension de la diversité architecturale mondiale.</p>
    </div>`,
    semesters: [
      {
        title: "1ère ANNÉE :TRONC COMMUN",
        sub_title: "Les outils analytiques et conceptuels",
        subjects: [
          "Principes de gestion I",
          "Comptabilité financière I",
          "Micro-économie",
          "Mathématiques I : Analyse",
          "Introduction au droit",
          "Mathématiques financières",
          "Business English I",
          "Aptitude en TIC I : Préparation à la certification",
          "Méthodologie et communocation I",
          "Projet 360° I",
          "Séminaire métiers I",
          "Business English II",
          "Principe de gestion II",
          "Comptabilité financière II",
          "Mathématiques II: Algèbre Statistiques descriptives et calculs de probabilité",
          "Projet 360° ||",
          "Séminaire métiers II",
        ],
      },
      {
        title: "2ème ANNÉE :TRONC COMMUN",
        sub_title: "Les domaines fonctionnels de l'entreprise",
        subjects: [
          "Fondamentaux du management",
          "Comptabilité de gestion",
          "Fondamentaux du marketing",
          "Communication digitale",
          "Business English III",
          "Gestion de la production",
          "Scrum master: Préparation à la certification",
          "Statistiques inférentielles",
          "Projet 360° III",
          "Séminaire métiers III",
          "Fondamentaux de la GRH",
          "Méthodologie et communication III",
          "Business English IV",
          "Event marketing",
          "Introduction au Big Data et Cloud",
          "Diagnostic financier",
          "Projet 360° IV",
          "Séminaire métiers IV",
        ],
      },
      {
        title: "3ème ANNÉE:LA SPÉCIALISATION",
        sub_title: "Parcours Finance",
        subjects: [
          "Gestion financière internationale",
          "Excel Avancé Comptabilité : Préparation à la certification",
          "Contrôle de gestion",
          "Gestion des institutions financières",
          "Econométrie appliquée à la finance",
          "Simulation au trading sur le marché boursier",
          "Gestion de portefeuille",
          "Projet 360° V",
          "Séminaire Métiers V",
          "Etude de cas en finance (Méthodologie)",
          "Business English V",
          "Théorie de la décision",
          "Politiques financières de l'entreprise",
          "Séminaire de méthodologie PFE",
          "Business English VI",
          "ACCESS: Préparation à la certification",
          "Finlabs: Salle de marché virtuelle",
          "Ingénierie financière et montages Blockchains & Crypto-currency financiers",
          "Projet 360° VI",
          "Séminaire Métiers VI",
        ],
      },
    ],
  },
  {
    id: 1,
    title: "LICENCE EN COMPATIBILITE",
    description:
      "La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise.",
    link: "BUSINESS",
    long_desc: `La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise. Les étudiants développeront également des compétences en leadership, en gestion de projet et en résolution de problèmes. Ce programme vise avant tout à former des leaders atypiques et créatives à l'impact positif sur le monde des entreprises et de la société.`,
    duration: " 3 ans",
    duration_type: "Temps Plein",
    cond_adm: " Baccalauréat ou équivalent ",
    langue: "Français - English ",
    type: "lisence",
    objectifs: `<div>
    <h2><strong>OBJECTIFS DU DIPLOME NATIONAL D'ARCHITECTE :</strong></h2>
    <p>1 - Fournir une éducation architecturale complète en développant la créativité, les compétences techniques et la sensibilité artistique des étudiants.</p>
    <p>2 - Former les étudiants à résoudre des problèmes architecturaux complexes en tenant compte des besoins fonctionnels, esthétiques, environnementaux et sociaux.</p>
    <p>3 - Offrir une expérience pratique grâce à une année de stage professionnalisant, permettant aux étudiants d'appliquer les connaissances théoriques dans un contexte professionnel.</p>
    <p>4 - Cultiver des compétences en communication, en collaboration et en gestion de projet, essentielles pour le succès dans la pratique architecturale.</p>
    <p>5 - Encourager une réflexion critique grâce au mémoire de stage, favorisant une analyse approfondie des expériences professionnelles.</p>
    <p>6 - Élargir les horizons des étudiants par le biais de voyages d'études internationaux, enrichissant leur compréhension de la diversité architecturale mondiale.</p>
    </div>`,
    semesters: [
      {
        title: "1ère ANNÉE :TRONC COMMUN",
        sub_title: "Les outils analytiques et conceptuels",
        subjects: [
          "Principes de gestion I",
          "Comptabilité financière I",
          "Micro-économie",
          "Mathématiques I : Analyse",
          "Introduction au droit",
          "Mathématiques financières",
          "Business English I",
          "Aptitude en TIC I : Préparation à la certification",
          "Méthodologie et communocation I",
          "Projet 360° I",
          "Séminaire métiers I",
          "Business English II",
          "Principe de gestion II",
          "Comptabilité financière II",
          "Mathématiques II: Algèbre Statistiques descriptives et calculs de probabilité",
          "Projet 360° ||",
          "Séminaire métiers II",
        ],
      },
      {
        title: "2ème ANNÉE :TRONC COMMUN",
        sub_title: "Les domaines fonctionnels de l'entreprise",
        subjects: [
          "Fondamentaux du management",
          "Comptabilité de gestion",
          "Fondamentaux du marketing",
          "Communication digitale",
          "Business English III",
          "Gestion de la production",
          "Scrum master: Préparation à la certification",
          "Statistiques inférentielles",
          "Projet 360° III",
          "Séminaire métiers III",
          "Fondamentaux de la GRH",
          "Méthodologie et communication III",
          "Business English IV",
          "Event marketing",
          "Introduction au Big Data et Cloud",
          "Diagnostic financier",
          "Projet 360° IV",
          "Séminaire métiers IV",
        ],
      },
      {
        title: "3ème ANNÉE: LA SPÉCIALISATION",
        sub_title: "Gestion comptable et financière avancée",
        subjects: [
          "Comptabilité avancée",
          "Cadre conceptuel et présentation des états financiers",
          "Contrôle de gestion",
          "Comptabilité publique",
          "Projet 360° V",
          "Séminaire Métiers V",
          "Audit",
          "Décisions financières",
          "Séminaire de méthodologie PFE",
          "Business English VI",
          "Comptabilité internationale: IFRS",
          "Comptabilité internationale: IPSAS",
          "Étude de cas en comptabilité",
          "Excel Avancé Comptabilité : Préparation à la certification",
          "Business English",
          "ACCESS: Préparation à la certification",
          "Projet 360° VI",
          "Séminaire Métiers VI",
        ],
      },
    ],
  },
  {
    id: 3,
    title: "LICENCE EN MARKETING",
    description:
      "La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise.",
    link: "BUSINESS",
    long_desc: `La licence en Sciences de Gestion est un programme d'études complet et rigoureux de 3 ans qui offre aux étudiants une vision globale de tous les aspects de la gestion d'entreprise. Les étudiants développeront également des compétences en leadership, en gestion de projet et en résolution de problèmes. Ce programme vise avant tout à former des leaders atypiques et créatives à l'impact positif sur le monde des entreprises et de la société.`,
    duration: " 3 ans",
    duration_type: "Temps Plein",
    cond_adm: " Baccalauréat ou équivalent ",
    langue: "Français - English ",
    type: "lisence",
    objectifs: `<div>
    <h2><strong>OBJECTIFS DU DIPLOME NATIONAL D'ARCHITECTE :</strong></h2>
    <p>1 - Fournir une éducation architecturale complète en développant la créativité, les compétences techniques et la sensibilité artistique des étudiants.</p>
    <p>2 - Former les étudiants à résoudre des problèmes architecturaux complexes en tenant compte des besoins fonctionnels, esthétiques, environnementaux et sociaux.</p>
    <p>3 - Offrir une expérience pratique grâce à une année de stage professionnalisant, permettant aux étudiants d'appliquer les connaissances théoriques dans un contexte professionnel.</p>
    <p>4 - Cultiver des compétences en communication, en collaboration et en gestion de projet, essentielles pour le succès dans la pratique architecturale.</p>
    <p>5 - Encourager une réflexion critique grâce au mémoire de stage, favorisant une analyse approfondie des expériences professionnelles.</p>
    <p>6 - Élargir les horizons des étudiants par le biais de voyages d'études internationaux, enrichissant leur compréhension de la diversité architecturale mondiale.</p>
    </div>`,
    semesters: [
      {
        title: "1ère ANNÉE :TRONC COMMUN",
        sub_title: "Les outils analytiques et conceptuels",
        subjects: [
          "Principes de gestion I",
          "Comptabilité financière I",
          "Micro-économie",
          "Mathématiques I : Analyse",
          "Introduction au droit",
          "Mathématiques financières",
          "Business English I",
          "Aptitude en TIC I : Préparation à la certification",
          "Méthodologie et communocation I",
          "Projet 360° I",
          "Séminaire métiers I",
          "Business English II",
          "Principe de gestion II",
          "Comptabilité financière II",
          "Mathématiques II: Algèbre Statistiques descriptives et calculs de probabilité",
          "Projet 360° ||",
          "Séminaire métiers II",
        ],
      },
      {
        title: "2ème ANNÉE :TRONC COMMUN",
        sub_title: "Les domaines fonctionnels de l'entreprise",
        subjects: [
          "Fondamentaux du management",
          "Comptabilité de gestion",
          "Fondamentaux du marketing",
          "Communication digitale",
          "Business English III",
          "Gestion de la production",
          "Scrum master: Préparation à la certification",
          "Statistiques inférentielles",
          "Projet 360° III",
          "Séminaire métiers III",
          "Fondamentaux de la GRH",
          "Méthodologie et communication III",
          "Business English IV",
          "Event marketing",
          "Introduction au Big Data et Cloud",
          "Diagnostic financier",
          "Projet 360° IV",
          "Séminaire métiers IV",
        ],
      },
      {
        title: "3ème ANNÉE: LA SPÉCIALISATION",
        sub_title: "Parcours Marketing",
        subjects: [
          "Stratégie Marketing",
          "Gestion des prix et des produits",
          "Recherche marketing",
          "Analyse du comportement du consommateur",
          "Étude de cas en marketing",
          "Préparation à la certification",
          "Séminaire Métiers V",
          "Project Management I: Préparation à la certification",
          "Digital marketing",
          "Business English V",
          "Stratégies de Distribution",
          "Management de la qualité",
          "Communication marketing",
          "Analyse des données Marketing",
          "Business English VI",
          "Project Management II: Préparation à la certification",
          "Référencement des sites web",
          "SCRUM master: Préparation à la",
          "certification",
          "Séminaire de méthodologie (PFE)",
          "Projet 360° VI",
          "Séminaire métiers VI",
        ],
      },
    ],
  },
  {
    id: 4,
    title: "LICENCE EN BUSINESS INTELLIGENCE (BI)",
    description:
      "Les étudiants acquièrent des compétences techniques en matière d'analyse de données, de modélisation de données, de programmation informatique et d'utilisation d'outils de Bl.",
    link: "BUSINESS",
    long_desc: `La Licence en Business Intelligence » vise à former des professionnels capables de concevoir et de mettre en place les moyens, les outils et les méthodes permettant de collecter, consolider, modéliser et restituer les données d'une entreprise. Les étudiants acquièrent des compétences techniques en matière d'analyse de données, de modélisation de données, de programmation informatique et d'utilisation d'outils de Bl.`,
    duration: "3 ans",
    duration_type: "Temps Plein",
    cond_adm: "Baccalauréat ou équivalent",
    langue: "Français",
    type: "lisence",
    objectifs: `<div>
    <h2><strong>OBJECTIFS DU DIPLOME NATIONAL D'ARCHITECTE :</strong></h2>
    <p>1 - Fournir une éducation architecturale complète en développant la créativité, les compétences techniques et la sensibilité artistique des étudiants.</p>
    <p>2 - Former les étudiants à résoudre des problèmes architecturaux complexes en tenant compte des besoins fonctionnels, esthétiques, environnementaux et sociaux.</p>
    <p>3 - Offrir une expérience pratique grâce à une année de stage professionnalisant, permettant aux étudiants d'appliquer les connaissances théoriques dans un contexte professionnel.</p>
    <p>4 - Cultiver des compétences en communication, en collaboration et en gestion de projet, essentielles pour le succès dans la pratique architecturale.</p>
    <p>5 - Encourager une réflexion critique grâce au mémoire de stage, favorisant une analyse approfondie des expériences professionnelles.</p>
    <p>6 - Élargir les horizons des étudiants par le biais de voyages d'études internationaux, enrichissant leur compréhension de la diversité architecturale mondiale.</p>
    </div>`,
    semesters: [
      {
        title: "1ère ANNÉE : Introduction à la BI",
        sub_title: "Conception et Analyse de données",
        subjects: [
          " Algorithmique et structures de données I",
          " Systèmes d'exploitation",
          " Systèmes logiques et architecture des ordinateurs",
          " Analyse",
          " Statistiques et probabilités",
          " Principes de gestion",
          " Comptabilité générale ",
          " Compétences numériques",
          " Développement personnel",
          " Business communication I",
          " Initiation au business game",
          " Programmation événementielle",
          " Algorithmique et structures de données II (TP)",
          " Algorithmique et structures",
          " de données II (Cours)",
          " Fondements des réseaux Introduction aux systèmes d'informations",
          " Macro-économie",
          " Droit des sociétés commerciales",
          " Business English II",
          " Aptitude en TIC II: Préparation à la certification",
          " Méthodologie & communication II",
          " Projet 360° ||",
          " Séminaire métiers I ",
          " Commerce électronique",
          " Projet d'Intégration Multidisciplinaire (PIM) I ",
          " Stratégies de résolution de problèmes l",
        ],
      },
      {
        title: "2ème ANNÉE",
        sub_title: "Data warehousing, Datamining et Analyse décisionnelle",
        subjects: [
          "Programmation OO",
          "Programmation web I",
          "Conception OO des systèmes d'information",
          "Statistiques inférentielles",
          "Fondements de l'IA ",
          "Marketing digital",
          "Projet professionnel personnel PPP  ",
          "Projet d'Intégration",
          "Multidisciplinaire PIM",
          "Atelier de génie logiciel (AGL)",
          "IOT",
          "Économie numérique",
          "Droit de l'informatique",
          "Base de données",
          "Analyse et fouille des données",
          "Programmation web II ",
          "Théories des graphes et recherche opérationnelle",
          "Architecture logicielle",
          "SGBD",
          "Modélisation multidimensionnelle et entrepôt de données",
          "Entrepreneuriat",
          "Transformation digitale TOEIC II: Préparation à la certification",
          "Initiation au langage python ",
          "Programmation OO avancée",
        ],
      },
      {
        title: "3ème ANNÉE",
        sub_title: "Big Data, Cloud, Data Governance et Gestion de projets",
        subjects: [
          "Techniques de prévision",
          "Fondements de la théorie de décision",
          "Introduction au Big data et Cloud",
          "Développement mobile",
          "Gestion de la technologie de",
          "l'information (ERP, SCM...) ",
          "Les fondamentaux de la sécurité IT",
          "Languages de programmation évalués-BI",
          "Power BI: Préparation à la certification  ",
          "TOEIC : Préparation à la certification",
          "Référencement des sites web Scrum Master: Préparation à la certification",
          "Conception TB et scoring logiciel de reporting",
          "Stage de PFE",
        ],
      },
    ],
  },
];
